var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"basic-component"},[(_vm.data)?_c('div',{staticClass:"container"},[_c('h1',[_vm._v("THIS IS BASIC COMPONENT")]),_c('h1',[_vm._v(_vm._s(_vm.data.fields.title))])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }